import React from "react";

interface Product {
  id: string;
  name: string;
  icon?: string;
}

interface Variant {
  name?: string;
}

interface OrderItemProps {
  orderItem: {
    product: Product;
    quantity: number;
    mrp: number;
    total_amount: number;
    variant_value?: string;
    variant?: Variant;
    validity_info?: string;
    type_name?: string;
  };
}

const EcommerceOrderProduct: React.FC<OrderItemProps> = ({ orderItem }) => {
  const {
    product,
    quantity,
    mrp,
    total_amount,
    variant_value,
    variant,
    validity_info,
    type_name
  } = orderItem;
  console.log("orderItem=========", orderItem);
  const formatAmount = (amount: number | undefined): string =>
    amount !== undefined ? new Intl.NumberFormat("en-IN").format(amount) : "—";

  return (
    <tr>
      <td>
        <div className="d-flex align-items-center">
          <div className="avatar-md bg-light rounded overflow-hidden">
            <img
              src={product?.icon || "/default-icon.png"}
              alt={product?.name || "Product"}
              className="img-fluid w-100 h-100 object-fit-cover"
            />
          </div>
          <div className="ms-3">
            <h6 className="mb-1">
              <a href={`/products/view/${product?.id}`} className="text-primary d-flex align-items-center">
                {product?.name || "Unnamed Product"}
                {type_name && (
                  <span className={`badge ms-2 ${type_name === 'Subscription' ? 'bg-success-subtle text-success' : 'bg-primary-subtle text-primary'}`} style={{ fontSize: '10px' }}>
                    {type_name}
                  </span>
                )}
              </a>
            </h6>
            <p className="text-muted mb-0">
              Variant: <strong>{variant_value} {variant?.name}</strong>
              {validity_info && (
                <span className="badge bg-warning-subtle text-warning ms-2">
                  <i className="ri-calendar-event-line me-1"></i>
                  {validity_info}
                </span>
              )}
            </p>
          </div>
        </div>
      </td>
      <td>₹{mrp}</td>
      <td>{quantity}</td>
      <td className="fw-medium text-end">₹{formatAmount(total_amount)}</td>
    </tr>
  );
};

export default EcommerceOrderProduct;
